import { render, staticRenderFns } from "./embedded_iframe.vue.js?vue&type=template&id=3ac618fc!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./embedded_iframe.vue?vue&type=template&id=3ac618fc"
import script from "./embedded_iframe.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./embedded_iframe.vue?vue&type=script&lang=js"
export * from "./embedded_iframe.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./embedded_iframe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/gitlab-gdk/gitlab-development-kit/gitlab/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ac618fc')) {
      api.createRecord('3ac618fc', component.options)
    } else {
      api.reload('3ac618fc', component.options)
    }
    module.hot.accept("./embedded_iframe.vue.js?vue&type=template&id=3ac618fc!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./embedded_iframe.vue?vue&type=template&id=3ac618fc", function () {
      api.rerender('3ac618fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "behaviors/components/embedded_iframe.vue"
export default component.exports